import home from './home';
import contact from "./contact";
import login from "./login";
import signup from "./signup";
import careers from "./careers";
import labs from "./labs";

import news from "./news";
import company from './company';

const pages = {
    name: 'pages',
    label: 'Pages',
    files: [
        home('en'),
        home('cn'),
        careers('en'),
        careers('cn') ,
        company('en'),
        company('cn'),
        labs('en'),
        labs('cn'),
        news('en'),
        news('cn'),
        contact('en'),
        contact('cn'),
        login,
        signup ],
}

export default pages
